/* === AgLinearProgress — Anagogia Design System === */

import styles from './AgLinearProgress.module.css';

export interface AgLinearProgressProps {
  /** 0–100 for determinate, omit for indeterminate */
  value?: number;
  /** Show percentage label */
  showLabel?: boolean;
  size?: 'sm' | 'md' | 'lg';
  color?: 'primary' | 'secondary' | 'success' | 'warning' | 'error' | 'info' | 'inherit';
  className?: string;
  style?: React.CSSProperties;
}

const COLOR_MAP: Record<string, string> = {
  primary: styles.colorPrimary,
  secondary: styles.colorSecondary,
  success: styles.colorSuccess,
  warning: styles.colorWarning,
  error: styles.colorError,
  info: styles.colorInfo,
  inherit: styles.colorInherit,
};

/**
 * Barre de progression linéaire, déterminée ou indéterminée.
 * @category Feedback
 */
function AgLinearProgress({
  value,
  showLabel,
  size = 'md',
  color = 'primary',
  className,
  style,
}: AgLinearProgressProps) {
  const determinate = value !== undefined;
  const clamped = determinate ? Math.max(0, Math.min(100, value)) : 0;

  const trackCls = [styles.track, styles[size], className].filter(Boolean).join(' ');
  const barCls = [determinate ? styles.bar : styles.indeterminate, COLOR_MAP[color]].filter(Boolean).join(' ');

  const track = (
    <div
      className={trackCls}
      style={style}
      role="progressbar"
      aria-valuenow={determinate ? clamped : undefined}
      aria-valuemin={determinate ? 0 : undefined}
      aria-valuemax={determinate ? 100 : undefined}
    >
      <div
        className={barCls}
        style={determinate ? { width: `${clamped}%` } : undefined}
      />
    </div>
  );

  if (showLabel && determinate) {
    return (
      <div className={styles.withLabel}>
        {track}
        <span className={styles.label}>{Math.round(clamped)}%</span>
      </div>
    );
  }

  return track;
}

export { AgLinearProgress };
export default AgLinearProgress;
